import type { Product, ProductFilters, Category } from '../../types/product'
import { mockDb } from '../db'

const simulateDelay = (min = 200, max = 500): Promise<void> => {
  const delay = Math.random() * (max - min) + min
  return new Promise(resolve => setTimeout(resolve, delay))
}

export const productService = {
  async getProducts(filters?: ProductFilters): Promise<{ products: Product[], total: number }> {
    await simulateDelay()
    const products = mockDb.getProducts(filters)
    const total = mockDb.getTotalCount(filters)
    return { products, total }
  },

  async getProductById(id: string): Promise<Product | undefined> {
    await simulateDelay()
    return mockDb.getProductById(id)
  },

  async getProductBySlug(slug: string): Promise<Product | undefined> {
    await simulateDelay()
    return mockDb.getProductBySlug(slug)
  },

  async getTodayDeals(): Promise<Product[]> {
    await simulateDelay()
    return mockDb.getTodayDeals()
  },

  async searchProducts(query: string, limit = 10): Promise<Product[]> {
    await simulateDelay(100, 300)
    return mockDb.searchProducts(query, limit)
  },

  async getCategories(): Promise<Category[]> {
    await simulateDelay(100, 200)
    return mockDb.getCategories()
  },
}
